import { render, staticRenderFns } from "./ViberForm.vue?vue&type=template&id=dd552e60&scoped=true"
import script from "./ViberForm.vue?vue&type=script&lang=js"
export * from "./ViberForm.vue?vue&type=script&lang=js"
import style0 from "./ViberForm.vue?vue&type=style&index=0&id=dd552e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd552e60",
  null
  
)

export default component.exports